import { Tab } from '../../core/services/interface';
import { ModalModule } from "ngx-bootstrap/modal";
import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { TabNames, common_components_map } from "src/app/core/services/constants";
import { MiddlwareService } from "src/app/core/services/middleware.service";

@Component({
  selector: "app-mobile-view-tab",
  templateUrl: "./mobile-view-tab.component.html",
  styleUrls: ["./mobile-view-tab.component.scss"],
})
export class MobileViewTabComponent implements OnInit {
  updateBuilderComponentSubscription: any;
  tabNames = TabNames;
  mode;
  mobileViewModeMap;
  inputData;
  image: string;
  tab_image: string;
  start_color: string;
  end_color: string;
  bg_color: string;
  @Input() inputTab: any;
  @Input() fontSmaller: boolean;

  fontResize= true;

  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    public ref: ChangeDetectorRef
  ) {}

  ngOnInit() {

    this.mobileViewModeMap = common_components_map;
    this.updateBuilderComponentSubscription =
      this.mdw.updateBuilderComponentContainer$.subscribe((data) => {
        if (data) {
          if (this.inputTab){
            this.inputData = this.inputTab;
          }else
          {
            this.inputData = data.tab;

          }
               this.image = "./assets/images/mobile-view-builder-item-empty-s.webp";

          if (this.inputData.tab_bg && this.inputData.tab_bg.image) {
            this.tab_image = this.inputData.tab_bg.image;
          } else if (this.inputData.tab_bg) {
            this.start_color = this.inputData.tab_bg.start
              ? this.inputData.tab_bg.start
              : null;
            this.end_color = this.inputData.tab_bg.end
              ? this.inputData.tab_bg.end
              : null;

            if (!this.end_color && this.start_color) {
              this.bg_color = this.start_color;
            } else if (!this.start_color && this.end_color) {
              this.bg_color = this.end_color;
            }
          } else {
            this.tab_image = null;
            this.bg_color = null;
            this.start_color = null;
            this.end_color = null;
          }
        }
      });
  }

  get setTabBg() {
    if (this.tab_image) {
      return {
        "background-image": `url(${this.tab_image})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover",
      };
    } else if (this.start_color && this.end_color) {
      return {
        "background-image": `linear-gradient(90deg, ${this.start_color}, ${this.end_color})`,
      };
    } else if (this.bg_color) {
      return { background: this.bg_color };
    }
    return { background: "unset" };
  }

  ngOnDestroy(): void {
    // console.log("destroy");
    if (this.updateBuilderComponentSubscription) {
      this.updateBuilderComponentSubscription.unsubscribe();
    }
  }
}
